import React from 'react';
import { useAppContext } from '../../../context/AppContext';
import { strings } from '../../../localization';
import { ViewItem } from './ViewItem';

export const SystemViews = () => {
    const { security } = useAppContext();

    const defaultSystemViewItemProps: { id: string; closeViewPicker: boolean; unFavouritable: boolean; parentID: number; folder: boolean } = {
        id: '',
        closeViewPicker: true,
        unFavouritable: true,
        parentID: 0,
        folder: false,
    };

    return (
        <>
            {security?.entry?.filter?.activeEntries?.canView && (
                <ViewItem
                    key={`view-item-activeEntries`}
                    caption={strings.View_Label_ActiveEntries}
                    listType={'DYNAMIC'}
                    viewType={'ACTIVE_ENTRIES'}
                    {...defaultSystemViewItemProps}
                />
            )}
            {security?.entry?.filter?.allEntries?.canView && (
                <ViewItem
                    {...defaultSystemViewItemProps}
                    key={`view-item-allEntries`}
                    caption={strings.View_Label_AllEntries}
                    listType={'DYNAMIC'}
                    viewType={'ALL_ENTRIES'}
                />
            )}
        </>
    );
};
